import { Component, inject } from '@angular/core';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { SchoolService } from '../../schools/services/school-service/school-service';

@Component({
  selector: 'app-school-picker',
  imports: [MatMenu, MatMenuItem, MatMenuTrigger, MatIcon, MatButton],
  templateUrl: './school-picker.html',
})
export class SchoolPicker {
  schoolService = inject(SchoolService);
}
